import { Component, OnInit, ViewChild } from '@angular/core';
import { Params, Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import swal from 'sweetalert2';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HttpClient } from '@angular/common/http';
import { APIUrl } from 'src/app/features-common/constants/APIUrls';
import { JwtHelperService } from "@auth0/angular-jwt";
const helper = new JwtHelperService();

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent extends FeaturesBaseComponent implements OnInit {
  otp: number  // it can be type string if you don't set allowNumbersOnly to true
  username: string;
  config = {
    allowNumbersOnly: true, // this is false by default
    setTypePassword: false, // this is false by default
    length: 6, // the default is 4
    inputStyles: {
      width: '60px',
      height: '60px',
      border: '2px solid rgb(15, 34, 69)',
      'border-radius': '10px',
      'font-weight': 'bolder',
      color: 'rgb(15, 34, 69)',
    },
  };
  canSubmit: boolean = false;
  notification: any;
  notificationMethod: string;
  deviceDetails: any;
  locationDetails: any;
  notifyBy: any;
  rememberMe: string;
  constructor(private loginService: LoginService, private router: Router, private deviceService: DeviceDetectorService, private http: HttpClient
  ) {
    super();

    this.http.get('https://pinocate.co/json/?key=YBkA9fSHWcT2sA1ZE5hxzXUujshpzLY6EhouGQ1smQWY0x2eak').subscribe(
      res => {
        this.locationDetails = res
        this.deviceDetails = this.deviceService.getDeviceInfo();
      })
    if (localStorage.getItem('userVerify') && localStorage.getItem('userVerify')) {
      let _userverify = JSON.parse(localStorage.getItem('userVerify'));
      // console.log(_userverify)
      this.username = _userverify.username;
      this.notification = _userverify.notification;
      this.notifyBy = _userverify?.notifyBy;
      this.notificationMethod = this.notification == 'sms' ? "mobile number" : "email"
      if (localStorage.getItem('isRemeberMe') && localStorage.getItem('isRemeberMe')) {
        this.rememberMe = localStorage.getItem('isRemeberMe')
      }  
    }
    else {
      router.navigate(['/'])
    }
  }

  ngOnInit() {
    super.ngOnInit();
  }

  onOtpChange(e) {
    if (e.length >= 6) {
      this.otp = e;
      this.canSubmit = true;
    }
    else {
      this.canSubmit = false;
    }
  }

  submit() {
    if (this.username && this.username != null && this.username != undefined && this.username != '') {
      
      this.verifyCode()
    }
  }
  verifyCode() {
        let userInfo: any = {};
        userInfo['ip_address'] = this.locationDetails.ip,
        
        userInfo['device'] = this.deviceDetails.deviceType == 'desktop'? 'Computer': this.deviceDetails.deviceType,
        userInfo['system_access_type'] = 'Admin Portal'
        userInfo['user_os'] = this.deviceDetails.os
        userInfo['browser'] = this.deviceDetails.browser
        userInfo['os_version'] = this.deviceDetails.os_version
        userInfo['user_agent'] = this.deviceDetails.userAgent
        userInfo['login_system_location'] = `${this.locationDetails.city} , ${this.locationDetails.region}, ${this.locationDetails.country_name}`

        if (localStorage.getItem('isFrom') == 'forgot'){
          let url = APIUrl.verifyResetPasswordCode;
          this.loginService.verify(this.rememberMe,this.otp, this.username, userInfo, url).subscribe(res => {
            if (res['httpcode']== 200){
              localStorage.setItem('isFrom','')
              this.router.navigateByUrl('/reset-password');
              return
            }
          })
        }
        else{
          let url = APIUrl.verify;
          this.loginService.verify(this.rememberMe,this.otp, this.username, userInfo, url).subscribe(res => {
            if (res['httpcode'] == 200) {
              this.toastrService.success('Login Successful!', 'Success', { timeOut: 1500 })
              localStorage.setItem('accessToken', res.data.jwt);
              const decodedToken = helper.decodeToken(res.data.jwt);
              if(decodedToken.role == "Customer Service"){
                this.router.navigateByUrl('features/retailers/allretailers');
                return
              }else{
                this.router.navigateByUrl('/');
                return
              }
              
            }
          })
        }
      }

  onReSenedCode() {
    if (this.notification && this.username) {

      let params: Params =
      {
        username: this.username,
        notification: this.notification
      }

      this.loginService.resendCode(params).subscribe(e => {
        // console.log(e.data);
        let _res: any = e;

        if (e && _res.httpcode == 200 && _res.data != {}) {

          this.toastrService.success('Veify to proceed', 'Re-Generated OTP', {})
          // if()
          // this.router.navigate['/reset-password']
        }
      })
    }

  }
}